<script setup lang="ts">

import { faLink } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineActions from './DisciplineActions.vue'
import { useDisciplineGeneralControls } from '../model/discipline-general-controls.hook'

defineOptions({
  name: 'DisciplineGeneralControls',
})

const {
  canManageDisciplines,
  refIsSaving,
  refPaymentLinksUrl,
  setSubmitUpdate,
} = useDisciplineGeneralControls()
</script>

<template>
  <div class="discipline-general-controls">
    <BtnSecondary
      v-if="refPaymentLinksUrl"
      text="Generate payment link"
      color="black"
      :to="refPaymentLinksUrl"
    >
      <template #iconLeft>
        <AppIcon :icon="faLink" />
      </template>
    </BtnSecondary>
    <DisciplineActions />
    <BtnPrimary
      v-if="canManageDisciplines"
      text="Save"
      color="emerald"
      :disabled="refIsSaving"
      @click="setSubmitUpdate"
    />
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralControls.scss" />
